import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button, Accordion, Spinner } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { ArrowCounterclockwise, CheckLg } from "react-bootstrap-icons";
import { useSelector, useDispatch } from "react-redux";
import { actions as actionStep } from "../../../reducers/Step";
import { actions as actionStepTwo, getAccountNo, getCompanyCode, getContractNo, getEmail, getName, getPhone, getStore, getSSN4, getTotal, getCustomerStatus } from "../../../reducers/StepTwo";
import { actions as actionStepOne } from "../../../reducers/StepOne";
import { actions as actionPay, getData, getIndexCheck } from "../../../reducers/StepPay";
import { Alert } from "../../Alerts";
import FAMSA from "../../../config/constants";
import axios from "axios";
import { normalizeInput, currencyFormatter } from "../../generals/normalizaInput";
import CurrencyField from "../../generals/Fields/CurrencyField";
import Loading from "../../Loading";
import { getTypePay } from "../../../reducers/TypePayment";
import AccordionFamsa from "./AccordionFamsa";

const StepTwo = () => {
    const intl = useIntl();
    const distpatch = useDispatch();
    const AccountNo = useSelector(getAccountNo);
    const CompanyCode = useSelector(getCompanyCode);
    const ContractNo = useSelector(getContractNo);
    const Email = useSelector(getEmail);
    const Name = useSelector(getName);
    const Phone = useSelector(getPhone);
    const Store = useSelector(getStore);
    const SSN4 = useSelector(getSSN4);
    const type_pay = useSelector(getTypePay);
    const CustomerStatus = useSelector(getCustomerStatus);
    const DataPay = useSelector(getData);
    const total = useSelector(getTotal);
    const [paymentAllow, setPaymentAllow] = useState(true);
    const indexCheck = useSelector(getIndexCheck);
    const [loading, setLoading] = useState(false);

    const Customer = async () => {
        setLoading(true);
        const fullURL = FAMSA.SERVER.SERVER + `/api/Customer?AccountNo=${AccountNo}&CustomerStatus=${CustomerStatus}&companyId=${(type_pay === 1) ? "FAMSAINC" : "LOANS"}&location=${Store}&SSN4=${SSN4}`;
        await axios.get(fullURL).then((response) => {
            if (response.data.StatusCode === 0) {
                setLoading(false);
                const focusArea = [];
                response.data.Data.map((value, index) => {
                    //debugger
                    focusArea[index] = {
                        id: index,
                        AccountNo: value.AccountNo,
                        CompanyCode: value.CompanyCode,
                        ContractNo: value.ContractNo,
                        PastDueAmt: value.PastDueAmt,
                        PayOff: value.PayOff,
                        CurrentDueAmt: value.CurrentDueAmt,
                        CurrentDueDate: value.CurrentDueDate,
                        PayOffDate: value.PayOffDate,
                        CurrentDueDateSpa: value.CurrentDueDateSpa,
                        PayOffDateSpa: value.PayOffDateSpa,
                        Errors: value.Errors,
                        CutomerType: value.CutomerType,
                        checkPastDue: false,
                        checkCurrentMon: false,
                        checkContractOff: false,
                        checkOther: false,
                        otherValue: "0"
                    };
                    //distpatch(actionPay.setData(value));
                });
                distpatch(actionPay.setData(focusArea))
                if(focusArea[0].CutomerType === FAMSA.CUSTOMER_ALERT){
                    Alert("danger", "Alert!", intl.formatMessage({ id: "step.report.support-02" }));
                    setPaymentAllow(false);
                }
                //distpatch(actionPay.setData(response.data.Data));
            } else {
                setLoading(false);
                Alert("danger", "", response.data.Data.Errors[0].Message);
            }
        }).catch(error => {
            setLoading(false);
            if (error.response.status === 404) {
                Alert("danger", "Error", error.response.data.Message);
            } else if (error.response.data.StatusCode === 1) {
                Alert("danger", "Error", error.response.data.Data.Errors[0].Message);
            } else {
                Alert("danger", "Error", intl.formatMessage({ id: "step.report.support" }));
            }
        })
    }

    const handleNextPage = (event) => {
        event.preventDefault();
        // DataPay.map((value, index) => {
        //     if (!value.checkPastDue && !value.checkCurrentMon && !value.checkContractOff && !value.checkOther) {
        //         Alert("danger", "Error", intl.formatMessage({ id: "step.two.alert.error" }));
        //         return;
        //     }
        // });

        if (parseFloat(total) === 0) {
            Alert("danger", "Error", intl.formatMessage({ id: "step.two.total.error" }));
            return;
        } else {
            //distpatch(actionStepTwo.setTotal(auxTotal));
            distpatch(actionStep.nextPage());
        }
    }

    useEffect(() => {
        //console.log("total: ", parseFloat(total));
        distpatch(actionPay.reset());
        Customer();
    }, []);

    return (
        <>
            <Row className='justify-content-center mx-3 my-3'>
                <Col className="border-bottom border-bg-black" md={{ span: 11 }} sm={{ span: 5 }}>
                    <b className="famsa-text-info-title"><FormattedMessage id="step.two.label.name" />:</b>
                    <Row className="mx-3 my-3 text-uppercase text-muted"> {Name} </Row>
                </Col>
            </Row>
            <Row className='justify-content-center mx-3 my-3'>
                <Col className="border-bottom" md={{ span: 5 }} sm={{ span: 11 }}>
                    <b className="famsa-text-info-title"><FormattedMessage id="step.two.label.phone" />:</b>
                    <Row className="mx-3 my-3 text-muted"> {normalizeInput(Phone)} </Row>
                </Col>
                <Col className="border-bottom" md={{ span: 5, offset: 1 }} sm={{ span: 12 }}>
                    <b className="famsa-text-info-title"><FormattedMessage id="step.two.label.email" />:</b>
                    <Row className="mx-3 my-3 text-muted"> {Email} </Row>
                </Col>
            </Row>
            <Form>
                <Row className='justify-content-center my-3'>
                    <Col className="col-11">
                        <h4><b className="famsa-text-two-title"><FormattedMessage id="step.two.title" /></b></h4>
                    </Col>
                </Row>
                <Row className='justify-content-center my-3'>
                    <Col className="col-11">
                        {(loading) ?
                            <Loading />
                            : <AccordionFamsa />
                        }

                    </Col>
                </Row>
                {/* {(type_pay === 2) ?
                    <Row className='justify-content-center mx-5'>
                        <Col md={{ span: 5, offset: 7 }} className="text-end align-self-center p-2 famsa-text-note">
                            <FormattedMessage id="step.two.label.note" /> ${FAMSA.SERVER.TRANSACTION} <FormattedMessage id="step.two.note" />
                        </Col>
                    </Row>
                    : null} */}
                <Row className='justify-content-center mx-5 my-2'>
                    <Col className="text-end align-self-center" md={{ span: 9 }}><h4 className="famsa-text-gray"><b><FormattedMessage id="step.two.total" /></b></h4></Col>
                    <Col className="border text-end align-self-center p-2 famsa-bg-gray" md={{ span: 3 }} ><p className="my-1 famsa-text-total">{currencyFormatter({ currency: "USD", value: (type_pay === 2) ? (parseFloat(total) > 0) ? (parseFloat(FAMSA.SERVER.TRANSACTION) + parseFloat(total)) : 0 : parseFloat(total) })}</p></Col>
                </Row>
                <Row className='justify-content-center mx-1 my-5'>
                    <Col className="famsa-text-info-title">
                        <p><b><FormattedMessage id="step.two.footer1" /></b></p>
                    </Col>
                    <Col className="col-12 famsa-text-info-title">
                        <p><b><FormattedMessage id="step.two.footer2" /></b></p>
                    </Col>
                    <Col className="col-12 famsa-text-info-title">
                        <p><b><FormattedMessage id="step.two.footer3" /></b></p>
                    </Col>
                </Row>
                <Row className="justify-content-end mx-3 my-3">
                    <Col className="my-3" md={{ span: 4 }} sm={{ span: 12 }}>
                        <Button className="famsa-btn-gray famsa-btn-w fs-5" onClick={() => { distpatch(actionStep.prevPage()); distpatch(actionStepOne.reset()); distpatch(actionPay.reset()); }}><ArrowCounterclockwise className="me-3" /><FormattedMessage id="step.two.btn.back" /></Button>
                    </Col>
                    {(paymentAllow) ? <>
                        <Col className="my-3" md={{ span: 4 }} sm={{ span: 12 }}>
                            <Button className="famsa-btn-green famsa-btn-w fs-5" onClick={handleNextPage}><CheckLg className="me-3" /><FormattedMessage id="step.two.btn.next"/></Button>
                        </Col>
                    </>
                    : null
                    }
                    
                </Row>
            </Form>
        </>
    );
}

export default StepTwo;